/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Bankinformation1Inputs */

const de__field_bankinformation1 = /** @type {(inputs: _Field_Bankinformation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bankinformationen`)
};

/**

* @param {_Field_Bankinformation1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_bankinformation1 = /** @type {((inputs?: _Field_Bankinformation1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Bankinformation1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_bankinformation1(inputs)
});
export { _field_bankinformation1 as "_field_bankInformation" }